import { consoleLogger } from '../constants/console-logger';
import { DEEPLINK_DATA_MATCHER } from '../constants/deeplink';
/**
 * Any device which uses `window.location.href` as deeplink source and does not require a custom `onDeeplink` event handler
 * can simply use this class out of the box.
 *
 * If you require a custom `onDeeplink` event handler or a custom deeplink source (e.g. a container API) you can extend
 * from this class and override the default constructor functionality by passing in `true` for `overrideDefault` and then
 * manually setting `this.data` as per the device's custom requirements.
 */
export class Deeplink {
    /**
     * Contains the **decoded** deeplink payload that matches `deeplinkCheckPattern`.
     *
     * It will return an empty string if no matches found or if there was an error whilst decoding the URL.
     */
    data = '';
    constructor(deviceWindow = self, useLocationHrefDeeplink = true, deeplinkCheckPattern = DEEPLINK_DATA_MATCHER) {
        if (useLocationHrefDeeplink) {
            this.data = decodeDeeplink(deviceWindow.location.href, deeplinkCheckPattern);
        }
    }
    /**
     * @param {DeeplinkCallback} eventHandler - this is a callback that is to called when the device receives a deeplink whilst foregrounded
     */
    onDeeplink(_eventHandler) {
        // override on a per device basis
    }
}
export const decodeDeeplink = (encodedDeeplink, deeplinkCheckPattern = DEEPLINK_DATA_MATCHER) => {
    if (encodedDeeplink) {
        try {
            const decodedDeeplink = decodeURIComponent(encodedDeeplink.replace(/\+/g, '%20'));
            const decodedDeeplinkMatches = deeplinkCheckPattern.exec(decodedDeeplink);
            if (decodedDeeplinkMatches && decodedDeeplinkMatches.length > 0) {
                return decodedDeeplinkMatches[1];
            }
        }
        catch (e) {
            consoleLogger.error('Unable to decode deeplink', encodedDeeplink, e);
        }
    }
    return '';
};
//# sourceMappingURL=deeplink.js.map